module.exports = __webpack_public_path__ + "static/media/5.3 Eisvogel Rahmen klein.94531621.jpg";